var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VMenu",
    {
      staticClass: "menu-component",
      attrs: {
        lazy: "",
        contentClass: "contrast",
        offsetY: "",
        closeOnContentClick: _vm.closeOnContentClick,
        left: "",
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _vm._t("activator", null, { slot: "activator" }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }